import type { ReactNode } from 'react';
import { IntegrationsProvider } from './context/IntegrationsContext';

/** App-wide integrations context (sidebar dynamic nav + localStorage state). */
export function IntegrationsBootstrap({ children }: { children: ReactNode }) {
  return <IntegrationsProvider>{children}</IntegrationsProvider>;
}
